import { useNativeAppEvents } from '../controller/useNativeAppEvents';
import { useNativeExternalLinks } from '../controller/useNativeExternalLinks';

export function NativeAppEvents() {
  useNativeAppEvents();
  useNativeExternalLinks();
  return null;
}
